export default "__VITE_ASSET__BJuu7rmb__"